const STATE_FORM = "STATE_FORM";
const STATE_CALCULATOR = "STATE_CALCULATOR";
const STATE_ACCOUNT_DETIAL = "STATE_ACCOUNT_DETIAL";
const STATE_OVERVIEW = "STATE_OVERVIEW";

export { STATE_FORM, STATE_CALCULATOR, STATE_ACCOUNT_DETIAL, STATE_OVERVIEW };
